import React from "react";
import "./LandingPage.css";

import logo from "../../assets/phronesis-logo.webp";
import dash from "../../assets/trade-dash.webp";
import qkLogo from "../../assets/qk_logo.png";
import { useNavigate } from "react-router-dom";
// const LandingPage = () => {
//   const navigate = useNavigate();
//   return (
//     <div className="landing-container">
//       <div className="content">
//         <div className="img-content">
//           <img src={qkLogo} alt="Trade Smart Logo" className="logo-image" />
//         </div>

//         <h1 className="headline">
//           Trade smarter.
//           <br />
//           Not harder.
//         </h1>

//         <p className="subheading">
//           Advanced option analytics, max pain, PCR and live insights built for
//           serious traders.
//         </p>

//         <ul className="feature-list">
//           <li>📊 Live Option Chain Analysis</li>
//           <li>⚡ Max Pain & PCR Insights</li>
//           <li>🔒 Secure & Fast Platform</li>
//         </ul>

//         <div className="button-group">
//           <button className="signup" onClick={() => navigate("/register")}>
//             Get Started Free
//           </button>
//           <button className="login" onClick={() => navigate("/loginpage")}>
//             Login
//           </button>
//         </div>
//       </div>

//       {/* Right side visual (desktop only) */}
//       <div className="hero-visual">
//         <img src={dash} alt="Trading dashboard preview" />
//       </div>
//     </div>
//   );
// };

// const LandingPage = () => {
//   const navigate = useNavigate();

//   return (
//     <div className="lp">
//       {/* ── NAV ── */}
//       <nav className="lp-nav">
//         <div className="lp-nav-inner">
//           <div className="lp-logo">
//             {/* Add your logo src below */}
//             <img src={qkLogo} alt="QuantKubera" className="lp-logo-img" />
//             <span className="lp-logo-text">QuantKubera</span>
//           </div>
//           <div className="lp-nav-links">
//             <a href="#features">Features</a>
//             <a href="#how">How It Works</a>
//             <button
//               className="lp-btn-ghost"
//               onClick={() => navigate("/loginpage")}
//             >
//               Login
//             </button>
//             <button
//               className="lp-btn-primary"
//               onClick={() => navigate("/register")}
//             >
//               Get Started Free
//             </button>
//           </div>

//           {/* Mobile hamburger */}
//           <button
//             className="lp-hamburger"
//             onClick={() =>
//               document.getElementById("lpMobileNav").classList.toggle("open")
//             }
//             aria-label="Open menu"
//           >
//             <span />
//             <span />
//             <span />
//           </button>
//         </div>
//       </nav>

//       {/* ── MOBILE NAV ── */}
//       <div className="lp-mobile-nav" id="lpMobileNav">
//         <button
//           className="lp-mobile-close"
//           onClick={() =>
//             document.getElementById("lpMobileNav").classList.remove("open")
//           }
//           aria-label="Close menu"
//         >
//           &times;
//         </button>
//         <a
//           href="#features"
//           onClick={() =>
//             document.getElementById("lpMobileNav").classList.remove("open")
//           }
//         >
//           Features
//         </a>
//         <a
//           href="#how"
//           onClick={() =>
//             document.getElementById("lpMobileNav").classList.remove("open")
//           }
//         >
//           How It Works
//         </a>
//         <button
//           className="lp-btn-ghost"
//           onClick={() => {
//             navigate("/loginpage");
//             document.getElementById("lpMobileNav").classList.remove("open");
//           }}
//         >
//           Login
//         </button>
//         <button
//           className="lp-btn-primary"
//           onClick={() => {
//             navigate("/register");
//             document.getElementById("lpMobileNav").classList.remove("open");
//           }}
//         >
//           Get Started Free
//         </button>
//       </div>

//       {/* ── HERO ── */}
//       <section className="lp-hero">
//         <div className="lp-hero-content">
//           <div className="lp-badge">
//             <span className="lp-badge-dot" />
//             Real-time options intelligence
//           </div>

//           <h1 className="lp-headline">
//             Trade smarter.
//             <br />
//             <span className="lp-accent">Not harder.</span>
//           </h1>

//           <p className="lp-subtitle">
//             Option chain analytics, max pain, PCR, trends and market insights —
//             all in one dashboard built for options traders.
//           </p>

//           <div className="lp-hero-actions">
//             <button
//               className="lp-btn-primary lg"
//               onClick={() => navigate("/register")}
//             >
//               Get Started Free
//               <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
//                 <path
//                   d="M3 8h10m0 0L9 4m4 4L9 12"
//                   stroke="currentColor"
//                   strokeWidth="2"
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                 />
//               </svg>
//             </button>
//             <button
//               className="lp-btn-secondary lg"
//               onClick={() => navigate("/loginpage")}
//             >
//               Login
//             </button>
//           </div>
//         </div>

//         <div className="lp-hero-visual">
//           <div className="lp-dash-frame">
//             <div className="lp-dash-bar">
//               <span className="lp-dot red" />
//               <span className="lp-dot yellow" />
//               <span className="lp-dot green" />
//             </div>
//             <div className="lp-dash-img-wrap">
//               {/* Add your dashboard screenshot src below */}
//               <img src="" alt="Trading dashboard preview" />
//               <div className="lp-live-tag">
//                 <span className="lp-live-blink" />
//                 LIVE
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* ── FEATURES ── */}
//       <section className="lp-features" id="features">
//         <p className="lp-section-label">Why QuantKubera</p>
//         <h2 className="lp-section-title">
//           Everything you need for options trading, in one place.
//         </h2>

//         <div className="lp-features-grid">
//           <div className="lp-fcard">
//             <div className="lp-ficon chain">
//               <svg
//                 width="22"
//                 height="22"
//                 viewBox="0 0 24 24"
//                 fill="none"
//                 stroke="currentColor"
//                 strokeWidth="2"
//                 strokeLinecap="round"
//               >
//                 <path d="M3 3v18h18" />
//                 <path d="M7 16l4-8 4 4 5-9" />
//               </svg>
//             </div>
//             <h3>Option Chain</h3>
//             <p>
//               View strikes, open interest, IV and volume across the full option
//               chain in one clean dashboard.
//             </p>
//           </div>

//           <div className="lp-fcard">
//             <div className="lp-ficon pcr">
//               <svg
//                 width="22"
//                 height="22"
//                 viewBox="0 0 24 24"
//                 fill="none"
//                 stroke="currentColor"
//                 strokeWidth="2"
//                 strokeLinecap="round"
//               >
//                 <circle cx="12" cy="12" r="10" />
//                 <path d="M12 2a10 10 0 0 1 0 20" />
//                 <path d="M12 8v8" />
//                 <path d="M8 12h8" />
//               </svg>
//             </div>
//             <h3>Max Pain & PCR</h3>
//             <p>
//               Track where market makers are positioned with max pain levels and
//               put-call ratio data at a glance.
//             </p>
//           </div>

//           <div className="lp-fcard">
//             <div className="lp-ficon trend">
//               <svg
//                 width="22"
//                 height="22"
//                 viewBox="0 0 24 24"
//                 fill="none"
//                 stroke="currentColor"
//                 strokeWidth="2"
//                 strokeLinecap="round"
//               >
//                 <path d="M2 20l7-7 4 4 9-11" />
//                 <path d="M16 6h6v6" />
//               </svg>
//             </div>
//             <h3>Trend Analysis</h3>
//             <p>
//               Spot directional shifts and momentum changes with built-in trend
//               indicators across your watchlist.
//             </p>
//           </div>

//           <div className="lp-fcard">
//             <div className="lp-ficon secure">
//               <svg
//                 width="22"
//                 height="22"
//                 viewBox="0 0 24 24"
//                 fill="none"
//                 stroke="currentColor"
//                 strokeWidth="2"
//                 strokeLinecap="round"
//               >
//                 <rect x="3" y="11" width="18" height="11" rx="2" />
//                 <path d="M7 11V7a5 5 0 0 1 10 0v4" />
//               </svg>
//             </div>
//             <h3>Secure & Fast</h3>
//             <p>
//               Your data stays private with encrypted connections, and the
//               platform is built for speed — no lag.
//             </p>
//           </div>
//         </div>
//       </section>

//       {/* ── HOW IT WORKS ── */}
//       <section className="lp-how" id="how">
//         <p className="lp-section-label">How It Works</p>
//         <h2 className="lp-section-title">
//           From signup to signal in under 2 minutes.
//         </h2>

//         <div className="lp-steps">
//           <div className="lp-step">
//             <div className="lp-step-num">1</div>
//             <h3>Create your account</h3>
//             <p>
//               Sign up for free — no credit card required. Get instant access to
//               the dashboard.
//             </p>
//           </div>
//           <div className="lp-step">
//             <div className="lp-step-num">2</div>
//             <h3>Pick your symbols</h3>
//             <p>
//               Add the tickers you trade. QuantKubera starts streaming live
//               option chain data immediately.
//             </p>
//           </div>
//           <div className="lp-step">
//             <div className="lp-step-num">3</div>
//             <h3>Trade with clarity</h3>
//             <p>
//               Use PCR, max pain, and OI data to spot opportunity and manage risk
//               in real time.
//             </p>
//           </div>
//         </div>
//       </section>

//       {/* ── CTA ── */}
//       <section className="lp-cta">
//         <div className="lp-cta-box">
//           <h2>Ready to read the market?</h2>
//           <p>
//             Stop guessing and start using data to make better trades. Free to
//             start, no card required.
//           </p>
//           <button
//             className="lp-btn-primary lg"
//             onClick={() => navigate("/register")}
//           >
//             Get Started Free
//             <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
//               <path
//                 d="M3 8h10m0 0L9 4m4 4L9 12"
//                 stroke="currentColor"
//                 strokeWidth="2"
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//               />
//             </svg>
//           </button>
//         </div>
//       </section>

//       {/* ── FOOTER ── */}
//       <footer className="lp-footer">
//         <p>&copy; 2026 QuantKubera. All rights reserved.</p>
//         <div className="lp-footer-links">
//           <a href="#">Privacy</a>
//           <a href="#">Terms</a>
//           <a href="#">Contact</a>
//         </div>
//       </footer>
//     </div>
//   );
// };

const LandingPage = () => {
  const navigate = useNavigate();

  return (
    <div className="lp">
      {/* ── NAV ── */}
      <nav className="lp-nav">
        <div className="lp-nav-inner">
          <div className="lp-logo">
            {/* Add your logo src below */}
            <img src={qkLogo} alt="QuantKubera" className="lp-logo-img" />
            <span className="lp-logo-text">QuantKubera</span>
          </div>
          <div className="lp-nav-links">
            <a href="#features">Features</a>
            <a href="#how">How It Works</a>
            <button
              className="lp-btn-ghost"
              onClick={() => navigate("/loginpage")}
            >
              Login
            </button>
            <button
              className="lp-btn-primary"
              onClick={() => navigate("/register")}
            >
              Get Started Free
            </button>
          </div>

          {/* Mobile hamburger */}
          <button
            className="lp-hamburger"
            onClick={() =>
              document.getElementById("lpMobileNav").classList.toggle("open")
            }
            aria-label="Open menu"
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </nav>

      {/* ── MOBILE NAV ── */}
      <div className="lp-mobile-nav" id="lpMobileNav">
        <button
          className="lp-mobile-close"
          onClick={() =>
            document.getElementById("lpMobileNav").classList.remove("open")
          }
          aria-label="Close menu"
        >
          &times;
        </button>
        <a
          href="#features"
          onClick={() =>
            document.getElementById("lpMobileNav").classList.remove("open")
          }
        >
          Features
        </a>
        <a
          href="#how"
          onClick={() =>
            document.getElementById("lpMobileNav").classList.remove("open")
          }
        >
          How It Works
        </a>
        <button
          className="lp-btn-ghost"
          onClick={() => {
            navigate("/loginpage");
            document.getElementById("lpMobileNav").classList.remove("open");
          }}
        >
          Login
        </button>
        <button
          className="lp-btn-primary"
          onClick={() => {
            navigate("/register");
            document.getElementById("lpMobileNav").classList.remove("open");
          }}
        >
          Get Started Free
        </button>
      </div>

      {/* ── HERO ── */}
      <section className="lp-hero">
        <div className="lp-hero-content">
          {/* <div className="lp-badge">
            <span className="lp-badge-dot" />
            Real-time options intelligence
          </div> */}

          <h1 className="lp-headline">
            Trade smarter.
            <br />
            <span className="lp-accent">Not harder.</span>
          </h1>

          <p className="lp-subtitle">
            Option chain analytics, max pain, PCR, trends and market insights —
            all in one dashboard built for options traders.
          </p>

          <div className="lp-hero-actions">
            <button
              className="lp-btn-primary lg"
              onClick={() => navigate("/register")}
            >
              Get Started Free
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path
                  d="M3 8h10m0 0L9 4m4 4L9 12"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
            <button
              className="lp-btn-secondary lg"
              onClick={() => navigate("/loginpage")}
            >
              Login
            </button>
          </div>
        </div>

        <div className="lp-hero-visual">
          <div className="lp-dash-frame">
            <div className="lp-dash-bar">
              <span className="lp-dot red" />
              <span className="lp-dot lp-yellow" />
              <span className="lp-dot lp-green" />
            </div>
            <div className="lp-dash-body">
              <div className="lp-dash-header">
                <h3>NIFTY Options Dashboard</h3>
                <div className="lp-live-tag">
                  <span className="lp-live-blink" />
                  LIVE
                </div>
              </div>
              <div className="lp-kpi-row">
                <div className="lp-kpi">
                  <div className="lp-kpi-label">PCR</div>
                  <div className="lp-kpi-value lp-green">0.82</div>
                  <div className="lp-kpi-change up">▲ 0.04</div>
                </div>
                <div className="lp-kpi">
                  <div className="lp-kpi-label">Max Pain</div>
                  <div className="lp-kpi-value">22,400</div>
                  <div className="lp-kpi-change up">▲ 50</div>
                </div>
                <div className="lp-kpi">
                  <div className="lp-kpi-label">IV Rank</div>
                  <div className="lp-kpi-value lp-red">67.2</div>
                  <div className="lp-kpi-change down">▼ 1.8</div>
                </div>
              </div>
              <div className="lp-mini-chart">
                <div className="lp-mini-chart-label">
                  OI Change — Calls vs Puts
                </div>
                <div className="lp-chart-bars">
                  {[
                    45, 62, 38, 85, 55, 72, 48, 92, 60, 40, 75, 68, 50, 82, 35,
                    58,
                  ].map((h, i) => (
                    <div
                      key={i}
                      className={`lp-bar${[3, 7, 11].includes(i) ? " active" : ""}`}
                      style={{ height: `${h}%` }}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── FEATURES ── */}
      <section className="lp-features" id="features">
        <p className="lp-section-label">Why QuantKubera</p>
        <h2 className="lp-section-title">
          Everything you need for options trading, in one place.
        </h2>

        <div className="lp-features-grid">
          <div className="lp-fcard">
            <div className="lp-ficon chain">
              <svg
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              >
                <path d="M3 3v18h18" />
                <path d="M7 16l4-8 4 4 5-9" />
              </svg>
            </div>
            <h3>Option Chain</h3>
            <p>
              View strikes, open interest, IV and volume across the full option
              chain in one clean dashboard.
            </p>
          </div>

          <div className="lp-fcard">
            <div className="lp-ficon pcr">
              <svg
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              >
                <circle cx="12" cy="12" r="10" />
                <path d="M12 2a10 10 0 0 1 0 20" />
                <path d="M12 8v8" />
                <path d="M8 12h8" />
              </svg>
            </div>
            <h3>Max Pain & PCR</h3>
            <p>
              Track where market makers are positioned with max pain levels and
              put-call ratio data at a glance.
            </p>
          </div>

          <div className="lp-fcard">
            <div className="lp-ficon trend">
              <svg
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              >
                <path d="M2 20l7-7 4 4 9-11" />
                <path d="M16 6h6v6" />
              </svg>
            </div>
            <h3>Trend Analysis</h3>
            <p>
              Spot directional shifts and momentum changes with built-in trend
              indicators across your watchlist.
            </p>
          </div>

          <div className="lp-fcard">
            <div className="lp-ficon secure">
              <svg
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              >
                <rect x="3" y="11" width="18" height="11" rx="2" />
                <path d="M7 11V7a5 5 0 0 1 10 0v4" />
              </svg>
            </div>
            <h3>Secure & Fast</h3>
            <p>
              Your data stays private with encrypted connections, and the
              platform is built for speed — no lag.
            </p>
          </div>
        </div>
      </section>

      {/* ── HOW IT WORKS ── */}
      <section className="lp-how" id="how">
        <p className="lp-section-label">How It Works</p>
        <h2 className="lp-section-title">
          From signup to signal in under 2 minutes.
        </h2>

        <div className="lp-steps">
          <div className="lp-step">
            <div className="lp-step-num">1</div>
            <h3>Create your account</h3>
            <p>
              Sign up for free — no credit card required. Get instant access to
              the dashboard.
            </p>
          </div>
          <div className="lp-step">
            <div className="lp-step-num">2</div>
            <h3>Pick your symbols</h3>
            <p>
              Add the tickers you trade. QuantKubera starts streaming live
              option chain data immediately.
            </p>
          </div>
          <div className="lp-step">
            <div className="lp-step-num">3</div>
            <h3>Trade with clarity</h3>
            <p>
              Use PCR, max pain, and OI data to spot opportunity and manage risk
              in real time.
            </p>
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section className="lp-cta">
        <div className="lp-cta-box">
          <h2>Ready to read the market?</h2>
          <p>
            Stop guessing and start using data to make better trades. Free to
            start, no card required.
          </p>
          <button
            className="lp-btn-primary lg"
            onClick={() => navigate("/register")}
          >
            Get Started Free
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path
                d="M3 8h10m0 0L9 4m4 4L9 12"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
      </section>

      {/* ── FOOTER ── */}
      <footer className="lp-footer">
        <p>&copy; 2026 QuantKubera. All rights reserved.</p>
        <div className="lp-footer-links">
          <a href="#">Privacy</a>
          <a href="#">Terms</a>
          <a href="#">Contact</a>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
